"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestedAnalysisSchema = exports.RequestedAnalysisStatusSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../helpers/schemas");
const schemas_2 = require("../../reporting/emotions/schemas");
const schemas_3 = require("../../mappings/schemas");
exports.RequestedAnalysisStatusSchema = zod_1.z.union([zod_1.z.literal('pending'), zod_1.z.literal('success'), zod_1.z.literal('failed')]);
const MappingMetricWithNameSchema = schemas_3.MappingMetricSchema.extend({ name: zod_1.z.string() });
const FunnelWithMetricsNamesSchema = schemas_3.FunnelSchema.omit({ metrics: true }).extend({
    metrics: zod_1.z.array(MappingMetricWithNameSchema),
});
const MappingWithMetricsNamesSchema = schemas_3.MappingSchema.omit({ funnels: true }).extend({
    funnels: zod_1.z.array(FunnelWithMetricsNamesSchema),
});
exports.RequestedAnalysisSchema = zod_1.z.object({
    id: zod_1.z.number(),
    mapping_id: zod_1.z.number(),
    from: schemas_1.ApiDateTimeSchema,
    until: schemas_1.ApiDateTimeSchema,
    status: exports.RequestedAnalysisStatusSchema,
    response: zod_1.z.object({
        mappingStructure: MappingWithMetricsNamesSchema,
        opportunitiesResponse: schemas_2.PostOpportunitiesResponseSchema.nullable(),
    }),
    createdAt: schemas_1.ApiDateTimeSchema,
    updatedAt: schemas_1.ApiDateTimeSchema,
});
//# sourceMappingURL=schemas.js.map